import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-levels2",
  "use": "icon-levels2-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-levels2\"><defs></defs><title>下级</title><path class=\"cls-1\" d=\"M14.4,9H9.67a1.66,1.66,0,0,0-1.6,1.7v.57H3V5.79A1.93,1.93,0,0,0,4.4,3.89a2,2,0,0,0-2-2,2,2,0,0,0-2,2,2,2,0,0,0,1.44,1.9v6a.58.58,0,0,0,.57.57H8.12V13a1.67,1.67,0,0,0,1.6,1.7H14.4A1.67,1.67,0,0,0,16,13V10.69A1.66,1.66,0,0,0,14.4,9Zm.47,4a.52.52,0,0,1-.47.56H9.72A.52.52,0,0,1,9.25,13V10.64a.53.53,0,0,1,.47-.57H14.4a.53.53,0,0,1,.47.57Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol